import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

/**
 * Protected Route Component for Admin Panel
 * Redirects to login if not authenticated or not admin
 * Subscribes to auth context for reactive updates
 */
const ProtectedRoute = ({ children }) => {
  const { auth } = useContext(AuthContext);
  const navigate = useNavigate();

  // Re-evaluate when auth state changes
  useEffect(() => {
    console.log('🛡️ ProtectedRoute: auth.isLoggedIn =', auth.isLoggedIn);
    if (!auth.isLoggedIn) {
      console.log('🚀 Redirecting to /login');
      navigate('/login', { replace: true });
    }
  }, [auth.isLoggedIn, navigate]);

  // If not logged in, don't render children
  if (!auth.isLoggedIn) {
    console.log('🛡️ ProtectedRoute: Not logged in, returning null');
    return null;
  }

  return children;
};

export default ProtectedRoute;
